// extracted by mini-css-extract-plugin
export var imageButton = "image-button-module--imageButton--30w2X";
export var imageStyle = "image-button-module--imageStyle--mDJzF";
export var textStyle = "image-button-module--textStyle--19c1x";